import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import AdminServices from "services/AdminServices";
import {
  Table,
  TableHeader,
  TableCell,
  TableFooter,
  TableContainer,
  Select,
  Input,
  Button,
  Card,
  CardBody,
  Pagination,
} from "@windmill/react-ui";
import { useTranslation } from "react-i18next";
import { FiPlus } from "react-icons/fi";

import useAsync from "hooks/useAsync";
import useToggleDrawer from "hooks/useToggleDrawer";
import UploadManyTwo from "components/common/UploadManyTwo";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import MainDrawer from "components/drawer/MainDrawer";
import CheckBox from "components/form/CheckBox";
import useProductFilter from "hooks/useProductFilter";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import BulkActionDrawer from "components/drawer/BulkActionDrawer";
import TableLoading from "components/preloader/TableLoading";
import SettingServices from "services/SettingServices";
import MainModal from "components/modal/MainModal";
import CareerServices from "services/CareerServices";
import CareerDrawer from "components/drawer/CareerDrawer";
import CareerTable from "components/career/CareerTable";
import Loader from 'components/loader/Loader';


import * as XLSX from 'xlsx';

import ReactExport from "react-export-excel";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';

const Careers = () => {
  const { id, title, subtitle, short_description, description, allId, serviceId, handleDeleteMany, handleUpdateMany } =
    useToggleDrawer();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [adminprevilegesList, setAdminprevilegesList] = useState([]);



  const [exportData, setExportData] = useState([]);
  const exportToExcel = () => {
    const dataSet = exportData.map(item => ({
      Title: item.title,
      short_description: item.short_description.split(' ')
      .slice(0, 10) // Tronquer après 10 mots
      .join(' '),
      associated_Careers_Count: item?.associatedCareersCount,
    }));

    const ws = XLSX.utils.json_to_sheet(dataSet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Projects");
    XLSX.writeFile(wb, "careers.xlsx");
  };

  const exportToCSV = () => {
    const csvData = exportData.map(item => [
      item.title,
      item.short_description.split(' ')
      .slice(0, 10) // Tronquer après 10 mots
      .join(' '),
      item?.associatedCareersCount,
    ]);

    const csvContent = "data:text/csv;charset=utf-8," + csvData.map(e => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "careers.csv");
    document.body.appendChild(link);
    link.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [[t("CareerTitleTbl"), t("CareerShortDescriptionTbl"), t("AppliesTbl")]],
      body: exportData.map(item => [
      item.title,
      item.short_description.split(' ')
      .slice(0, 10) // Tronquer après 10 mots
      .join(' '),
      item?.associatedCareersCount,
      ]),
    });
    doc.save('careers.pdf');
  };

  useEffect(() => {
    setExportData(data);
  }, [data]);


  useEffect(() => {
    async function fetchAdminprevileges() {
      try {
        const adminInfoString = Cookies.get("adminInfo");

        if (adminInfoString) {
          const adminInfo = JSON.parse(adminInfoString);

          if (adminInfo && adminInfo.id) {
            const response = await AdminServices.getStaffById(adminInfo.id);

            const adminprevileges = response.data.previleges.map(obj => { return obj.slug });
            setAdminprevilegesList(adminprevileges);
          } else {
            console.log('ID de l\'admin non trouvé dans les informations');
          }
        } else {
          console.log('Cookie adminInfo non trouvé');
        }
      } catch (error) {
        console.log('Erreur lors de la récupération des privilèges', error);
      }
    }

    fetchAdminprevileges();
  }, []);

  const {
    toggleDrawer,
    lang,
    currentPage,
    handleChangePage,
    searchText,
    category,
    setCategory,
    searchRef,
    handleSubmitForAll,
    sortedField,
    setSortedField,
    limitData,
  } = useContext(SidebarContext);
  const [searchCareer, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchCareers = async (isLoading, searchCareer) => {
    try {
      let response;
      if (searchCareer) {
        response = await CareerServices.searchCareer(searchCareer);


      }
      else {
        response = await CareerServices.getAllCareers();
      }
      // Mettez à jour la variable data avec les données récupérées
      setData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des careers :", error);
    }
    finally {
      setIsLoading(false); // Mettre à jour l'état pour indiquer que le chargement est terminé
    }
  };

  useEffect(() => {
    fetchCareers(isLoading, searchCareer);
  }, [isLoading, searchCareer]);


  const handleSearchInputChange = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue); // Mettez à jour l'état avec la nouvelle valeur de recherche
  };

  // console.log("product page", data);

  // react hooks
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(data?.map((li) => li.id));
    // console.log('ischecktw', isCheck);
    if (isCheckAll) {
      setIsCheck([]);

    }
  };

  // console.log('productss',products)
  const {
    serviceData,
    filename,
    isDisabled,
    handleSelectFile,
    handleUploadMultiple,
    handleRemoveSelectFile,
  } = useProductFilter(data);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <PageTitle>{t("CareersPage")}</PageTitle>
      <DeleteModal id={serviceId} ids={allId} setIsCheck={setIsCheck} title={data.title} setIsLoading={setIsLoading} />
      <MainModal id={isCheck} title={data.title} setIsLoading={setIsLoading} />

      {/* <BulkActionDrawer ids={allId} data={data} title="Services" /> */}
      <MainDrawer>
        <CareerDrawer id={serviceId} setIsCheck={setIsCheck} setIsLoading={setIsLoading} isLoading={isLoading} isCheck={isCheck} />
      </MainDrawer>
      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
        <CardBody className="">
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 md:pb-0 grid gap-4 lg:gap-6 xl:gap-6  xl:flex"
          >
            <div className="flex justify-start xl:w-1/2  md:w-full">
              {/* <UploadManyTwo
                title="Careers"
                filename={filename}
                isDisabled={isDisabled}
                totalDoc={data?.totalDoc}
                handleSelectFile={handleSelectFile}
                handleUploadMultiple={handleUploadMultiple}
                handleRemoveSelectFile={handleRemoveSelectFile}
              /> */}
            </div>
            <div className="lg:flex  md:flex xl:justify-end xl:w-1/2  md:w-full md:justify-start flex-grow-0">

              <div className="w-full md:w-32 lg:w-32 xl:w-32 mr-3 mb-3 lg:mb-0">
                {/* {(adminprevilegesList?.includes("delete_career")) && (

                  <Button
                    disabled={isCheck?.length < 1}
                    onClick={() => handleDeleteMany(isCheck, data.products)}
                    className="w-full rounded-md h-12 bg-red-300 disabled btn-red"
                  >
                    <span className="mr-2">
                      <FiTrash2 />
                    </span>

                    {t("Delete")}
                  </Button>
                )} */}
              </div>
              <div className="w-full md:w-48 lg:w-48 xl:w-48">
                {(adminprevilegesList?.includes("create_career")) && (

                  <Button
                    onClick={toggleDrawer}
                    className="w-full rounded-md h-12"
                  >
                    <span className="mr-2">
                      <FiPlus />
                    </span>
                    {t("AddCareer")}
                  </Button>
                )}
              </div>
            </div>
          </form>
        </CardBody>
      </Card>

      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 rounded-t-lg rounded-0 mb-4">
        <CardBody>
          <form
            onSubmit={handleSubmitForAll}
            className="py-3 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex"
          >
            <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
              <Input
                ref={searchRef}
                className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                type="search"
                name="search"
                placeholder={t("SearchCareer")}
                onChange={handleSearchInputChange}
              />
              <button
                type="submit"
                className="absolute right-0 top-0 mt-5 mr-1"
              ></button>
            </div>
          </form>
        </CardBody>
      </Card>

      {serviceData?.length !== 0 ? (


<>
<div className="lg:flex   md:flex s:flex xl:w-1/3 lg:justify-end space-x-1 xl:justify-end ">

<Button
  onClick={exportToExcel}
  className="flex-1 rounded-md h-5 text-sm" 
>
  {t("Export to Excel")}
</Button>

<Button
  onClick={exportToCSV}
  className="flex-1 rounded-md h-5 text-sm"
>
  {t("Export to CSV")}
</Button>

<Button
  onClick={exportToPDF}
  className="flex-1 rounded-md h-5 text-sm"
>
  {t("Export to PDF")}
</Button>

</div>
<br/>
        <TableContainer className="mb-8 rounded-b-lg">
          <Table>
            <TableHeader>
              <tr>
                <TableCell>
                  {/* <CheckBox
                    type="checkbox"
                    name="selectAll"
                    id="selectAll"
                    isChecked={isCheckAll}
                    handleClick={handleSelectAll}
                  /> */}
                </TableCell>
                <TableCell>{t("CareerTitleTbl")}</TableCell>
                <TableCell>{t("CareerShortDescriptionTbl")}</TableCell>
                <TableCell>{t("AppliesTbl")}</TableCell>
                <TableCell className="text-center">{t("Details")}</TableCell>
                <TableCell className="text-right">{t("ActionsTbl")}</TableCell>
              </tr>
            </TableHeader>
            <CareerTable
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              lang={lang}
              isCheck={isCheck}
              Careers={data?.Careers}
              setIsCheck={setIsCheck}
              searchCareer={searchCareer}
              data={data}
              adminprevilegesList={adminprevilegesList}
            />
          </Table>
          {/* <TableFooter>
            <Pagination
              totalResults={data?.totalDoc}
              resultsPerPage={limitData}
              onChange={handleChangePage}
              label="Career Page Navigation"
            />
          </TableFooter> */}
        </TableContainer>
        </>
      ) : (
        <NotFound title="Career" />
      )}
    </>
  );
};

export default Careers;
